// extracted by mini-css-extract-plugin
module.exports = {"resetGreeting":"ResetPassword_resetGreeting__3nR8u","confirmButton":"ResetPassword_confirmButton__3VhZM","login":"ResetPassword_login__3EO8l"};